import React from "react";
import { Box, Typography } from "@mui/material";
import ChatContainer from "./ChatContainer";
import ErrorBoundary from "./ErrorBoundary";
import Layout from "../../components/Layout";
import { isLoggedIn } from "../../utils/utils";
import { Navigate } from 'react-router-dom';

const ChatPage = () => {
    // Check if user is logged in
    if (!isLoggedIn()) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Layout>
            <Box sx={{ 
                display: "flex", 
                flexDirection: "column",
                height: "100vh", // Full viewport height
                width: "calc(100% + 2rem)", // Compensate for layout padding
                overflow: "hidden",
                margin: "-1rem", // Remove all layout padding
                bgcolor: "background.default"
            }}>
                <ErrorBoundary>
                    <ChatContainer />
                </ErrorBoundary>
            </Box>
        </Layout>
    );
};

export default ChatPage; 